import React, { Component } from "react";
import PropTypes from "prop-types";
import { Utils } from "arv-reactcomponents";

import FilterList from "../FilterList";
import { filterInitialLength } from "npmlinks-constants";

class CategoryFilterBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLength: filterInitialLength,
      toggleShowMore: false,
    };
    this.moreButtonClick = this.moreButtonClick.bind(this);
    this.lessButtonClick = this.lessButtonClick.bind(this);
    this.shouldBeShown = this.shouldBeShown.bind(this);
  }

  get isHideMoreClassName() {
    return (
      ((this.state.toggleShowMore ||
        (this.props.categoryfilters.list &&
          this.props.categoryfilters.list.length <= filterInitialLength)) &&
        "nwc-hide") ||
      ""
    );
  }

  get isShowLessClassName() {
    return (!this.state.toggleShowMore && "nwc-hide") || "";
  }

  moreButtonClick() {
    this.setState({
      initialLength: this.props.categoryfilters.list.length,
      toggleShowMore: !this.state.toggleShowMore,
    });
  }
  shouldBeShown() {
    return this.props.newArrivalsfilters.count > 0 ||
      this.props.onSalefilters.count > 0
      ? ""
      : "nwc-hide";
  }

  lessButtonClick() {
    this.setState({
      initialLength: filterInitialLength,
      toggleShowMore: !this.state.toggleShowMore,
    });
  }

  render() {
    const {
      categoryfilters,
      newArrivalsfilters,
      onSalefilters,
      className,
    } = this.props;
    if (
      !(categoryfilters && categoryfilters.list) &&
      !(newArrivalsfilters && newArrivalsfilters.displayName) &&
      !(onSalefilters && onSalefilters.displayName)
    )
      return null;
    return (
      <form name="category" className="nw-categoryfilterblock">
        <div className="nw-categoryfilterblock-filterheadings">
          {categoryfilters.displayName}
        </div>
        <ul className="nw-categoryfilterblock-list">
          {categoryfilters.list &&
            categoryfilters.list
              .slice(0, this.state.initialLength)
              .map((list, index) => (
                <FilterList.component
                  index={index}
                  key={list.value}
                  filterlist={list}
                  name="All Categories"
                  className={className}
                  mapping={categoryfilters.mapping}
                  filterTitle={categoryfilters.displayName}
                />
              ))}
          <li
            role="presentation"
            onKeyPress={Utils.noop}
            onClick={this.moreButtonClick}
            className={`nw-categoryfilterblock-more ${
              this.isHideMoreClassName
            } ${className}`}
          >
            More
          </li>
          <li
            role="presentation"
            onKeyPress={Utils.noop}
            onClick={this.lessButtonClick}
            className={`nw-categoryfilterblock-more nw-categoryfilterblock-less ${
              this.isShowLessClassName
            } ${className}`}
          >
            Less
          </li>
        </ul>
        <ul className={`nw-categoryfilterblock-list ${this.shouldBeShown()}`}>
          {newArrivalsfilters &&
            newArrivalsfilters.displayName && (
              <FilterList.component
                index={1}
                key={1}
                filterlist={newArrivalsfilters}
                name={newArrivalsfilters.displayName}
                className={className}
                mapping={newArrivalsfilters.mapping}
                filterTitle={categoryfilters.displayName}
              />
            )}
          {onSalefilters &&
            onSalefilters.displayName && (
              <FilterList.component
                index={2}
                key={2}
                filterlist={onSalefilters}
                name={onSalefilters.displayName}
                className={className}
                mapping={onSalefilters.mapping}
                filterTitle={categoryfilters.displayName}
              />
            )}
        </ul>
      </form>
    );
  }
}

CategoryFilterBlock.defaultProps = {
  newArrivalsfilters: {},
  onSalefilters: {},
  className: "",
};

CategoryFilterBlock.propTypes = {
  className: PropTypes.string,
  categoryfilters: PropTypes.shape({
    list: PropTypes.oneOfType([
      PropTypes.shape({}).isRequired,
      PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    ]).isRequired,
    slice: PropTypes.func,
  }).isRequired,
  newArrivalsfilters: PropTypes.shape({
    count: PropTypes.number.isRequired,
  }),
  onSalefilters: PropTypes.shape({
    count: PropTypes.number.isRequired,
  }),
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CategoryFilterBlock,
  component: CategoryFilterBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/CategoryFilterBlock/index.js